import { Storage } from './Storage';
import { Logger } from './Logger';
import { on } from '../utils/Async';
import { TokenModel, TransactionModel } from '../models';

interface RequestParams extends RequestInit {
  anonymous?: boolean;
  body?: any;
  overridingBaseUrl?: string;
}

function request<T>(
  endpoint: string,
  method: 'GET' | 'POST' | 'PATCH' | 'DELETE' = 'GET',
  params: RequestParams = {} as RequestParams,
): Promise<T> {
  const {
    anonymous = false,
    body,
    overridingBaseUrl,
    headers,
    ...rest
  } = params;

  const config: RequestInit = {
    method,
    body: body ? JSON.stringify(body) : body,
    headers: {
      'Content-Type': 'application/json',
      ...!anonymous && { Authorization: `Bearer ${Storage.getUserToken()}` },
      ...headers,
    },
    ...rest,
  }

  const url = overridingBaseUrl
    ? overridingBaseUrl
    : `https://api.foongit.com${endpoint}`;
  return new Promise((resolve, reject) => {
    window
      .fetch(url, config)
      .then(async (response) => {
        if (response.ok) {
          const [responseBodyError, responseBody] = await on(response.json());
          if (responseBodyError) {
            if (response.status === 200 || response.status === 201) {
              // no body, and that's all good
              return resolve(undefined);
            }

            Logger.handleError({ error: responseBodyError });
            return reject(responseBodyError);
          }

          return resolve(responseBody);
        }

        const [errorResponseBodyError, errorResponseBody] = await on(response.json());
        if (errorResponseBodyError) {
          Logger.handleError({ error: response });
          return reject(errorResponseBodyError);
        }

        reject(errorResponseBody);
      }, (error) => {
        Logger.handleError({ error });
        reject(error);
      })
  });
}

export class Http {

  static calculateTransactionCost(amount: number): Promise<{ amount: number; cost: number; tier: 'one' | 'two' | 'three' | 'four'; detail: string; }> {
    return request(`/transactions/cost/${amount}`, 'GET', { anonymous: true });
  }

  static getTransactionToken(token: string | string[] | null): Promise<TokenModel<TransactionModel>> {
    return request(`/tokens/${token}/transaction`, 'PATCH', { anonymous: true });
  }
}
